import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '~/services/api/client';
import { ENDPOINTS } from '~/services/api/config';

export function useApiStatus(): ReturnType<typeof useQuery<boolean>> {
  return useQuery({
    queryKey: ['api-status'],
    queryFn: async () => {
      try {
        // Use /ping instead of /health - no DB connection needed
        await apiRequest(ENDPOINTS.PING);
        return true;
      } catch {
        return false;
      }
    },
    refetchInterval: 30000, // Check every 30 seconds
    refetchOnWindowFocus: true, // Check when window regains focus
    refetchOnMount: true, // Check when component mounts
    retry: 0, // Don't retry on failure
  });
}
